export enum OrderStatus {
  Undefined = 0,
  InProcess = 1,
  Closed = 2,
  Canceled = 3,
  CancelRequested = 4,
}
